'use client';

import {styled} from "@mui/system";
import {Box} from "@mui/material";

const IssueActiveBox = styled(Box)(({theme}) => ({
    fontWeight: '700',
    alignItems: 'center',
    justifyContent: 'space-between',
    display: 'flex',
    color: theme.palette.text.primary
}));

export default IssueActiveBox;
